import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";

import Login from "../views/Login.vue";
import Inicio from "../views/Inicio.vue";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Login",
		component: Login
	},
	{
		path: "/inicio",
		name: "Inicio",
		component: Inicio,
		meta: { requireAuth: true, nombre: "CENTRO+" }
	},
	{
		path: "/calendario",
		name: "Calendario",
		component: () => import("../views/Calendario.vue"),
		meta: { requireAuth: true, nombre: "Calendario de Eventos" }
	},
	{
		path: "/anuncios",
		name: "Anuncios",
		component: () => import("../views/Anuncios.vue"),
		meta: { requireAuth: true, nombre: "Anuncios UCAB" }
	},
	{
		path: "/consultas",
		name: "Consultas",
		component: () => import("../views/Consultas.vue"),
		meta: { requireAuth: true, nombre: "Horarios de Consultas" }
	},
	{
		path: "/consultas/:idmateria",
		name: "HoraConsulta",
		component: () => import("../views/Consultas.vue"),
		props: true,
		meta: { requireAuth: true }
	},
	{
		path: "/progresa",
		name: "Progresa",
		component: () => import("../views/Progresa.vue"),
		meta: { requireAuth: true, nombre: "Asesorías Académicas" }
	},
	{
		path: "/progresa/asesores",
		name: "Asesores",
		component: () => import("../views/Asesores.vue"),
		meta: { requireAuth: true, nombre: "Asesores" }
	},
	{
		path: "/material",
		name: "Material",
		component: () => import("../views/Material.vue"),
		meta: { requireAuth: true, nombre: "Material de estudio" }
	},
	{
		path: "/informacion",
		name: "Informacion",
		component: () => import("../views/Informacion.vue"),
		meta: { requireAuth: true, nombre: "Información" }
	},
	{
		path: "/contactos",
		name: "Contactos",
		component: () => import("../views/Contacto.vue"),
		meta: { requireAuth: true, nombre: "Contactos UCAB" }
	},
	{
		path: "/procesos",
		name: "Procesos",
		component: () => import("../views/Procesos.vue"),
		meta: { requireAuth: true, nombre: "Procesos UCAB" }
	},
	{
		path: "/contingencia",
		name: "Contingencia",
		component: () => import("../views/Contingencia.vue"),
		meta: { requireAuth: true, nombre: "Contingencia Académica" }
	},
	{
		path: "/configuracion",
		name: "Configuracion",
		component: () => import("../views/Configuracion.vue"),
		meta: { requireAuth: true, nombre: "Configuración" }
	},
	//EXTERNAL LINKS
	{
		path: "/ucalculadora",
		name: "Ucalculadora",
		beforeEnter() {
			location.href = "https://madot10.github.io/UCalculadora/";
		}
	},
	{
		path: "/horariosPlus",
		name: "HorariosPlus",
		beforeEnter() {
			location.href = "https://madot10.github.io/HorariosPlus/";
		}
	},
	{
		path: "/bibliotecaucab",
		name: "BibliotecaUcab",
		beforeEnter() {
			location.href = "https://biblioteca.ucab.edu.ve/";
		}
	},
	//NO ENCONTRADO
	{
		path: "*",
		name: "404",
		component: () => import("../views/Error.vue"),
		meta: { requireAuth: true, nombre: "ERROR" }
	}
];

const router = new VueRouter({
	base: process.env.BASE_URL,
	routes
});

router.beforeEach((to, from, next) => {
	const rutaProtegida = to.matched.some(record => record.meta.requireAuth);
	//console.log("ROUTER", to);

	//Title web
	if (to.meta.nombre && to.meta.nombre != "CENTRO+") {
		document.title = "Centro+ | " + to.meta.nombre;
	} else {
		document.title = "Centro+";
	}

	//Auth Route
	if (rutaProtegida && store.state.user_data) {
		//Puede Acceder = Protegida y Loged
		store.commit("setNombreVista", to.meta.nombre);
		//console.log("VISTA: ", to.meta.nombre);
		next();
	} else if (rutaProtegida && !store.state.user_data) {
		//Ruta protegida pero no logeado
		next({ name: "Login" });
	} else if (to.name == "Login" && store.state.user_data) {
		next({ name: "Inicio" });
	} else {
		//No es ruta protegida
		store.commit("setNombreVista", to.meta.nombre);
		//console.log("VISTA: ", to.meta.nombre);
		next();
	}
});

export default router;
